import { render, staticRenderFns } from "./FindPasswordPage.vue?vue&type=template&id=65cdae0e"
import script from "./FindPasswordPage.vue?vue&type=script&lang=js"
export * from "./FindPasswordPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports